import { find, get } from "lodash";
import { MDBSpinner } from "mdbreact";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import { resetStatusScanQrCodeInsurance } from "~/store/patient/patientAction";
import { requestHoliday } from "~/store/resource/resourceAction";
import {
  addSchedule,
  changeDirection,
  getBookingTree,
  goBackStep,
  resetSchedule,
  resetSelectDate,
  resetSelectTimeSlot,
  setScheduleWithoutDate
} from "~/store/totalData/actions";
import * as constants from "~/utils/constants";
import * as func from "~/utils/func";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ChooseCalendarDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/Schedules/ChooseCalendar"),
  loading: LoadableLoading
});
class ChooseCalendar extends Component {
  componentDidMount() {
    const {
      resetSchedule,
      resetSelectDate,
      resetSelectTimeSlot,
      requestHoliday,
      resetStatusScanQrCodeInsurance,
      getBookingTree,
      listDays,
      setScheduleWithoutDate,
      isAddNewSchedule
    } = this.props;

    const currentPagePartnerId = func.getPartnerFromUrl(
      this.props.history.location.pathname
    );

    if (listDays.length === 0) {
      getBookingTree({ partnerId: currentPagePartnerId });
    }

    if (!isAddNewSchedule) {
      resetSchedule();
      resetSelectDate();
      resetSelectTimeSlot();
    }

    requestHoliday();
    resetStatusScanQrCodeInsurance(); // reset chỗ scan mã BHYT
    setScheduleWithoutDate(false);
  }

  methods = {
    handleNextStep: () => {
      const {
        history,
        addSchedule,
        typeAction,
        partnerId,
        isAddNewSchedule
      } = this.props;
      addSchedule();

      if (typeAction === constants.TypeAction.SuaPhieuKham) {
        history.push(
          func.getRouteFollowPartnerId(
            constants.urlPage.Xac_Nhan_Thong_Tin,
            partnerId
          )
        );
      } else {
        if (isAddNewSchedule) {
          history.push(
            func.routerByPartnerId(
              constants.urlPage.Xac_Nhan_Thong_Tin,
              partnerId
            )
          );
        } else {
          history.push(constants.urlPage.Chon_Ho_So);
        }
      }
    },
    handleGoBack: () => {
      this.props.goBackStep("calendar");
    }
  };

  render() {
    const { listDays } = this.props;

    if (listDays.length === 0) {
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    }
    return (
      <React.Fragment>
        <ChooseCalendarDesktop {...this.props} {...this.methods} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    hospital: { selectedHospital },
    patient: { selectedPatient },
    totalData: {
      isAddNewSchedule,

      timeSlot: { timeId },
      days: { date: dateSelected, list: listDays },
      listNode,
      partnerId,
      service: { serviceType },
      typeAction
    },
    user: { IsAuthenticated },
    followUpExam: { patientExam }
  } = state;
  return {
    isAddNewSchedule,
    typeAction,
    device: type,
    selectedHospital,
    selectedPatient,
    serviceType,
    timeId,
    IsAuthenticated,
    dateSelected,
    listNode,
    partnerId,
    listDays,
    patientExam
  };
};

const ChooseCalendarHelmet = withTitle({
  component: ChooseCalendar,
  title: `${hospitalName.value} | Chọn lịch khám`
});

export default connect(mapStateToProps, {
  resetSelectDate,
  resetSelectTimeSlot,
  resetSchedule,
  addSchedule,
  changeDirection,
  requestHoliday,
  resetStatusScanQrCodeInsurance,
  goBackStep,
  getBookingTree,
  setScheduleWithoutDate
})(ChooseCalendarHelmet);
